export const MEMBERS = {
    "total": 11,
    "hasMore": false,
    "items": [
                {
            "id": "942225",
            "name": "rmontano@seidor.es",
            "displayName": "Renny Montaño",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1624953187042,
            "createdDateInISO8601Format": "2021-06-29T07:53:07.042Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1764248510394,
            "modifiedDateInISO8601Format": "2025-11-27T13:01:50.394Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/942221",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/942221",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
                        {
            "id": "942226",
            "name": "rlopezm@affinity-petcare.com",
            "displayName": "Rafael Lopez",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1624953187042,
            "createdDateInISO8601Format": "2021-06-29T07:53:07.042Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1764248510394,
            "modifiedDateInISO8601Format": "2025-11-27T13:01:50.394Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/942221",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/942221",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
                                {
            "id": "942227",
            "name": "jpontac@affinity-petcare.com",
            "displayName": "J. Ponta C.",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1624953187042,
            "createdDateInISO8601Format": "2021-06-29T07:53:07.042Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1764248510394,
            "modifiedDateInISO8601Format": "2025-11-27T13:01:50.394Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/942221",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/942221",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "942221",
            "name": "albert.baucells@seidor.com",
            "displayName": "Albert Baucells",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1624953187042,
            "createdDateInISO8601Format": "2021-06-29T07:53:07.042Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1764248510394,
            "modifiedDateInISO8601Format": "2025-11-27T13:01:50.394Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/942221",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/942221",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "665497",
            "name": "alopez@affinity-petcare.com",
            "displayName": "Alfredo Lopez",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810513219,
            "createdDateInISO8601Format": "2021-03-15T12:15:13.219Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1752140192749,
            "modifiedDateInISO8601Format": "2025-07-10T09:36:32.749Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/665497",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/665497",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "1360457",
            "name": "blucchesi@affinity-petcare.com",
            "displayName": "Beatrice Lucchesi",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1662473226866,
            "createdDateInISO8601Format": "2022-09-06T14:07:06.866Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1764115956220,
            "modifiedDateInISO8601Format": "2025-11-26T00:12:36.220Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/1360457",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/1360457",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "54609",
            "name": "DAM_content@affinity-petcare.com",
            "displayName": "DAM Content",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1559051879634,
            "createdDateInISO8601Format": "2019-05-28T13:57:59.634Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1764233988292,
            "modifiedDateInISO8601Format": "2025-11-27T08:59:48.292Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/54609",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/54609",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "88491",
            "name": "dromero@affinity-petcare.com",
            "displayName": "Dani Romero",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1564126887762,
            "createdDateInISO8601Format": "2019-07-26T07:41:27.762Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1763563136042,
            "modifiedDateInISO8601Format": "2025-11-19T14:38:56.042Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/88491",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/88491",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "665065",
            "name": "dvila@affinity-petcare.com",
            "displayName": "David Vila",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810513121,
            "createdDateInISO8601Format": "2021-03-15T12:15:13.121Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1753347559318,
            "modifiedDateInISO8601Format": "2025-07-24T08:59:19.318Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/665065",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/665065",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "665233",
            "name": "egarcia@affinity-petcare.com",
            "displayName": "Encarna Garcia",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810513159,
            "createdDateInISO8601Format": "2021-03-15T12:15:13.159Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1757410544357,
            "modifiedDateInISO8601Format": "2025-09-09T09:35:44.357Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/665233",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/665233",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "658297",
            "name": "jfuset@affinity-petcare.com",
            "displayName": "Juanjo Fuset",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810476185,
            "createdDateInISO8601Format": "2021-03-15T12:14:36.185Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1763469980384,
            "modifiedDateInISO8601Format": "2025-11-18T12:46:20.384Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/658297",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/658297",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "654289",
            "name": "jplanas@affinity-petcare.com",
            "displayName": "Javier Planas",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810475144,
            "createdDateInISO8601Format": "2021-03-15T12:14:35.144Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1752140191113,
            "modifiedDateInISO8601Format": "2025-07-10T09:36:31.113Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/654289",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/654289",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "657481",
            "name": "pdelgado@affinity-petcare.com",
            "displayName": "Puri Delgado",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810475993,
            "createdDateInISO8601Format": "2021-03-15T12:14:35.993Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1752140206753,
            "modifiedDateInISO8601Format": "2025-07-10T09:36:46.753Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/657481",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/657481",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        },
        {
            "id": "656209",
            "name": "pgarcia@affinity-petcare.com",
            "displayName": "Pedro Garcia",
            "objectType": "waggle/user",
            "createdByID": "10048",
            "createdByUserName": "System",
            "createdByUserDisplayName": "System",
            "createdByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "createdDate": 1615810475687,
            "createdDateInISO8601Format": "2021-03-15T12:14:35.687Z",
            "modifiedByID": "10048",
            "modifiedByUserName": "System",
            "modifiedByUserDisplayName": "System",
            "modifiedByURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/10048",
            "modifiedDate": 1762840841673,
            "modifiedDateInISO8601Format": "2025-11-11T06:00:41.673Z",
            "isRemoved": false,
            "url": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/people/656209",
            "isDirect": true,
            "membersURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197/members/656209",
            "groupURL": "https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/social/api/v1/groups/1277197",
            "role": "GROUP_MANAGER",
            "groupOriginType": "CEC"
        }
    ]
}